import {
  SortDirection,
  type TableSort,
} from "@redotech/redo-views-common/table";

export type TableCardRow = string[];

/** Passed to Table2 explicitly so the row slice, the page control, and
 *  the reserved body height all agree on one number. */
export const PAGE_SIZE = 25;

/** Sort and page rows for one Table2 request. An absent `pageSize` means
 *  "every row" — Table2 omits it when exporting CSV. */
export function selectTableRows(
  rows: readonly TableCardRow[],
  headers: readonly string[],
  {
    sort,
    pageSize,
    pageNumber,
  }: { sort?: TableSort; pageSize?: number; pageNumber?: number },
): TableCardRow[] {
  const sorted = [...rows];

  const colIndex = sort
    ? headers.findIndex((_, i) => `col-${i}` === sort.key)
    : -1;
  if (sort && colIndex >= 0) {
    const dir = sort.direction === SortDirection.ASC ? 1 : -1;
    sorted.sort((a, b) => {
      const aVal = a[colIndex] ?? "";
      const bVal = b[colIndex] ?? "";
      const aNum = Number(aVal);
      const bNum = Number(bVal);
      if (!isNaN(aNum) && !isNaN(bNum) && aVal !== "" && bVal !== "") {
        return (aNum - bNum) * dir;
      }
      return aVal.localeCompare(bVal) * dir;
    });
  }

  if (pageSize === undefined) {
    return sorted;
  }
  const start = (pageNumber ?? 0) * pageSize;
  return sorted.slice(start, start + pageSize);
}
